import type { ReactNode } from "react";
import { Alert, Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy, List } from "@/shared/ui";
import { formatText } from "@/shared/ui/format";

export type StepFields = {};

interface Props extends AbstractStepProps {
	csokAmount: number;
	errorMessages: string[];
}

export class ResultCsokOnly extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { csokAmount } = this.props;

		return (
			<>
				<Card.Header>
					<Card.Title>
						A megadott adatok alapján jelenleg{" "}
						<strong className="text-danger">nincs számodra elérhető lakáshitel</strong>, mert:
					</Card.Title>
				</Card.Header>
				<Card.Body>
					{this.renderResult()}
					<div className="h3 my-auto text-center text-success">
						Az igényelhető CSOK összege:
						<br />
						<mark className="d-inline-block mt-2 bg-success text-white">
							{formatText(csokAmount, "ft")}
						</mark>
					</div>
					<div className="w-100 text-center">
						Ha szeretnéd megtudni hogyan igényelheted, add meg az adataidat és elküldjük a{" "}
						<strong>részletes CSOK tájékoztatónkat</strong>.
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy type="submit" variant="gold" size="lg">
						Adatok megadása
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	private renderResult(): ReactNode {
		const { errorMessages } = this.props;

		return (
			<Alert variant="danger">
				<List itemStyle="warning-triangle" className="mb-0">
					{errorMessages.map((error, key) => (
						<List.Item key={key}>{error}</List.Item>
					))}
				</List>
			</Alert>
		);
	}

	protected getComponentName(): string {
		return "ResultCsokOnly";
	}
}
